var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusPattern = function SvgPlusPattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 399"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.92,26.78h-9.84v-8.67h-9.06v-9.44h9.06V0h9.84v8.67h9.06v9.44h-9.06v8.67ZM64.5,25.36h7v-8.67h9.06v-6.6h-9.06V1.42h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.92,94.46h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM64.5,93.04h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.92,162.14h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM64.5,160.71h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.92,229.81h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM64.5,228.39h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.92,297.49h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM64.5,296.07h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.92,365.16h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM64.5,363.74h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.94,60.62h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM118.52,59.2h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.94,128.3h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM118.52,126.88h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.94,195.97h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM118.52,194.55h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.94,263.65h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM118.52,262.23h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.94,331.32h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM118.52,329.9h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.94,399h-9.84v-8.67h-9.06v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM118.52,397.58h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67h-9.06v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.9,60.62h-9.84v-8.67H0v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM10.48,59.2h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67H1.42v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.9,128.3h-9.84v-8.67H0v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM10.48,126.88h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67H1.42v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.9,195.97h-9.84v-8.67H0v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM10.48,194.55h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67H1.42v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.9,263.65h-9.84v-8.67H0v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM10.48,262.23h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67H1.42v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.9,331.32h-9.84v-8.67H0v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM10.48,329.9h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67H1.42v6.6h9.06v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.9,399h-9.84v-8.67H0v-9.44h9.06v-8.67h9.84v8.67h9.06v9.44h-9.06v8.67ZM10.48,397.58h7v-8.67h9.06v-6.6h-9.06v-8.67h-7v8.67H1.42v6.6h9.06v8.67Z"
  }))));
};
export default SvgPlusPattern;